import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import ReactGA from 'react-ga'
import { verifyMagicCode, forgotPassword, reWelcome } from '../../actions/users'
import { Container, Box, Typography, Textfield, Button, SwxTheme } from 'swx-atomic-component-lib'
import style from './style'
import _ from 'lodash'
import queryString from 'query-string'
import i18n from '../../i18n'
import ButtonWithSpinner from '../utils/ButtonWithSpinner'

function tempCodeVerification (props) {
  const [magicCode, setMagicCode] = useState('')
  const { email, closeModal, error, self, id, isCollaborate, module, needVerify, additionalParam = {} } = props
  const params = queryString.parse(window.location.search)
  const modalRef = useRef(null)

  useEffect(() => {
    if (self.siteApplication && !_.isEmpty(self.siteApplication)) {
      if (self.siteApplication.postCallbackUrl) {
        const form = document.createElement('form')
        document.body.appendChild(form)
        form.method = 'POST'
        form.action = self.siteApplication.postCallbackUrl

        const tokenInput = document.createElement('input')
        tokenInput.name = 'token'
        tokenInput.type = 'hidden'
        tokenInput.value = self.token
        form.appendChild(tokenInput)
        if (params.return) {
          const returnInput = document.createElement('input')
          returnInput.name = 'returnPath'
          returnInput.type = 'hidden'
          returnInput.value = decodeURIComponent(params.return)
          form.appendChild(returnInput)
        }
        form.submit()

        return
      }

      const newQs = `token=${self.token}`
      const returnUri = params.return || self.siteApplication.callbackUrl
      const qsSeparator = !_.isNull(decodeURIComponent(returnUri).match(/\?/)) ? '&' : '?'

      const finalURL = `${self.siteApplication.baseUrl}${returnUri}${qsSeparator}${newQs}`
      // // TODO: temporary put here until the design is out
      window.parent.postMessage({ action: 'completed', redirectURL: finalURL }, process.env.REACT_APP_POSTMESSAGE_WHITELIST_URL)
      window.location.href = finalURL
    }
  }, [self, null])

  function onChange (value) {
    setMagicCode(value.trim().toUpperCase())
  }

  function onClickSubmit () {
    ReactGA.event({ category: 'Authentication', action: 'Clicked Sign in', label: 'Magic Code' })
    props.verifyMagicCode(id, email, magicCode, params.clientId, additionalParam)
      .then(() => {
        if (!self || _.isEmpty(self.siteApplication)) {
          window.location.pathname = '/'
        }
      })
  }

  function onClickCancel () {
    ReactGA.event({ category: 'Authentication', action: 'Clicked Cancel', label: 'Magic Code' })
    closeModal()
  }

  function onRequestMagicCode () {
    ReactGA.event({ category: 'Authentication', action: 'Clicked Request new code', label: 'Magic Code' })
    module !== 'signup' && !needVerify ? props.forgotPassword({ email }) : props.reWelcome({ email, clientId: params.clientId, module })
  }

  function isMobile () {
    return (window.screen.width < 600)
  }

  function detectOutsideClick (ref) {
    useEffect(() => {
      function handleOutsideClick (event) {
        if (ref.current && !ref.current.contains(event.target)) {
          onClickCancel()
        }
      }

      document.addEventListener('mousedown', handleOutsideClick)
      return () => {
        document.removeEventListener('mousedown', handleOutsideClick)
      }
    }, [ref])
  }
  detectOutsideClick(modalRef)

  const embeddedContainerStyle = `
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    box-sizing: border-box;
    width: 100vw;
  `

  return (
    <div ref={modalRef}>
      <Container customStyle={isCollaborate ? embeddedContainerStyle : style.containerStyle}>
        <Box customStyle={style.contentBoxStyle}>
          <Typography customStyle={style.contentBoxTitleStyle} variant='bold'>{i18n.magicCodeModal.title}</Typography>
          <Box customStyle={style.magicCodeContainerStyle}>
            <Box customStyle={style.magicCodeInputContainerStyle}>
              <Textfield
                id='codeBox'
                key='codeBox'
                customStyle={style.magicCodeInputStyle}
                maxLength='4'
                onChange={(val) => onChange(val)}
              />
            </Box>
          </Box>
          <Box customStyle={style.messageContainer}>
            {
              !_.isEmpty(error) && (
                <Typography style={{ color: SwxTheme.palette.highlight, marginTop: '4px', fontSize: '12px' }}>{i18n.magicCodeModal.errorCode}</Typography>
              )
            }
            <Typography customStyle={style.instruction} onClick={onRequestMagicCode}>{i18n.magicCodeModal.instruction}{email}</Typography>
            <Typography customStyle={style.resendCode} onClick={onRequestMagicCode}>{i18n.magicCodeModal.requestNewLink}</Typography>
          </Box>
        </Box>
        <Box customStyle={style.ctaContainer}>
          <Box customStyle={isMobile() ? style.smallScreenButtonContainer : ''}>
            {!needVerify && !isCollaborate && (
              <Button
                ghost
                customStyle={style.buttonCancelStyle}
                onClick={onClickCancel}
              >
                {i18n.common.button.cancel}
              </Button>
            )}
            {
              module !== 'signup'
                ? (
                  <Button
                    customStyle={style.buttonPrimaryStyle}
                    onClick={onClickSubmit}
                    disabled={(self && self.isProcessing) || magicCode.length !== 4}
                  >
                    {i18n.common.button.signIn}
                  </Button>
                  )
                : (
                  <ButtonWithSpinner
                    isLoading={self.isProcessing}
                    value={i18n.common.button.verify}
                    disabled={magicCode.length !== 4}
                    onClick={onClickSubmit}
                    customStyle={style.buttonPrimaryStyle}
                  />
                  )
            }
          </Box>
        </Box>
      </Container>
    </div>
  )
}

function mapStateToProps (state) {
  // Whatever is returned will show up as props inside props of this component
  const { error } = state.self
  return {
    error,
    self: state.self
  }
}

export default connect(mapStateToProps, { verifyMagicCode, forgotPassword, reWelcome })(tempCodeVerification)
